import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import InlineCKEditor from '../../common/editor/inline-editor';
import ImageEditor from '../../common/editor/image-editor';
import { checkPermission } from '../../common/guards/can';
import { loadPageContent } from '../../../actions/content';
import PageTitle from '../../common/page-title/index';
import Extensions from './content-editor-extensions';
import { TOGGLE_EDIT_CONTENT } from "../../../reducers/viewReducer";

import './styles.css';

class ContentPage extends Component {
  componentWillMount() {
    const { dispatch, match } = this.props;
    const prefix = (match.params[0] === 'brands/') ? 'brands' : 'pages';

    dispatch(loadPageContent(`api/${prefix}/${match.params.pageSlug}`))
      .then(() => {
        const anchor = document.URL.split('#')[1];
        const element = document.getElementById(anchor);

        if (anchor && element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }

        if (checkPermission('edit', 'Page') && this.isEditAccordingToPath()) {
          dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: true});
        } else {
          this.props.dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: false});
        }
      });
  }

  componentWillUnmount() {
    this.props.dispatch({type: TOGGLE_EDIT_CONTENT, payLoad: false});
  }

  isEditAccordingToPath() {
    return this.props.match.path.split('/')[2] === 'edit';
  }

  handleContentSaved() {
  }

  render() {
    const { attributes } = this.props.page;
    const { pageSlug } = this.props.match.params;
    const { contents } = this.props;

    const editors = {
      text: {
        component: InlineCKEditor,
        props: {
          config: {
            width: '100%',
            height: '100%'
          },
          activeClass: 'content-editor',
        },
      },
      image: { component: ImageEditor }
    };

    return (
      <Grid className="content-page">
        <Row>
          <Col lg={12}>
            <PageTitle>{attributes && attributes.name}</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Extensions show={this.isEditAccordingToPath()} page={pageSlug}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {attributes && Object.keys(contents).map(key => {
              const editor = editors[contents[key].content_type];
              const EditorComponent = editor.component;
              const props = editor.hasOwnProperty('props') && editor.props;

              return (
                <EditorComponent
                  key={key}
                  identifier={key}
                  contents={contents[key]}
                  onContentSaved={this.handleContentSaved}
                  {...props}
                />
              )
            })}
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contents: state.content.list,
    page: state.content.page,
    edit: state.viewConfig.editContent,
  };
};

export default connect(mapStateToProps)(ContentPage);



// WEBPACK FOOTER //
// ./src/components/admin/content-page/index.jsx